/**
 * Custom error class for network unavailability failures.
 * Used to distinguish network errors from other errors in error handling.
 */
export class NetworkUnavailableError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'NetworkUnavailableError';
    // Maintains proper stack trace for where our error was thrown (only available on V8)
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, NetworkUnavailableError);
    }
  }
}
